import { Button } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { isIframed } from "../../helpers/utils";

const MARKETINGSITE = process.env.REACT_APP_MARKETING_SITE_URL;
const APPURL = process.env.REACT_APP_WEBAPP_URL;

export const LinkToApp = ({ link, children, linkClasses }) => {
  const { pathname } = useLocation();
  if (isIframed) {
    return (
      <Button
        onClick={() =>
          window.parent.postMessage({ redirect: APPURL + link }, "*")
        }
        className={linkClasses}
      >
        {children}
      </Button>
    );
  } else {
    const updatedLink =
      pathname && pathname.includes(link)
        ? {
            pathname: link,
            state: {
              closeUserMenu: true,
            },
          }
        : link;

    return (
      <Link to={updatedLink} className={linkClasses}>
        {children}
      </Link>
    );
  }
};

export const LinkToCommon = ({
  marketingLink,
  appLink,
  children,
  linkClasses,
}) => {
  const { pathname } = useLocation();
  if (isIframed) {
    return (
      <Button
        onClick={() =>
          window.parent.postMessage(
            { redirect: MARKETINGSITE + marketingLink },
            "*"
          )
        }
        className={linkClasses}
      >
        {children}
      </Button>
    );
  } else {
    const updatedLink =
      pathname && pathname.includes(appLink)
        ? {
            pathname: appLink,
            state: {
              closeUserMenu: true,
            },
          }
        : appLink;

    return (
      <Link to={updatedLink} className={linkClasses}>
        {children}
      </Link>
    );
  }
};

export const LinkToMarketing = ({ link, children, linkClasses }) => {
  if (isIframed) {
    return (
      <Button
        onClick={() => window.parent.postMessage({ redirect: link }, "*")}
        className={linkClasses}
      >
        {children}
      </Button>
    );
  } else {
    return (
      <a
        href={MARKETINGSITE + link}
        target="_blank"
        rel="noreferrer"
        className={linkClasses}
      >
        {children}
      </a>
    );
  }
};
